<template lang="html">
  <step
    :title="title"
    :icon="icon"
    :complete="complete"
    :step='step'>
    <v-container fluid>
      <v-card>
        <v-layout row wrap>
          <v-card-title>
            <h4> Select Desired Bus Type(s) for This Trip</h4>
          </v-card-title>
          <v-flex xs12>
            <v-layout row wrap justify-center>
              <v-flex xs4 v-for="(bus, index) in buses" :key="index">
                <bus-select
                  :buses="selectableBuses"
                  v-model="selectedBus"
                  @continue="confirmSelectedBus(buses.findIndex(b => b.id === bus.id))">
                  <template #activator=" { on } ">
                    <bus-card
                      :operator="operatorId"
                      :bus="bus"
                      text="Click to use a different bus"
                      :allowEdit="false"/>
                  </template>
                </bus-select>
              </v-flex>
              <v-flex xs6>
                <bus-select
                  :buses="selectableBuses"
                  v-model="selectedBus"
                  @continue="confirmSelectedBus">
                  <template #activator="{ on }">
                    <bus-card
                      :operator="operatorId"
                      text="Click to add a bus to this trip"
                      :allowEdit="false"
                      v-on="on"/>
                  </template>
                </bus-select>
              </v-flex>
            </v-layout>
          </v-flex>
        </v-layout>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            :disabled="!!loading"
            :loading="!!loading"
            @click="submit">
              Continue
            </v-btn>
        </v-card-actions>
      </v-card>
    </v-container>
  </step>
</template>

<script>

import { mapGetters, mapActions } from 'vuex';
import label from '@/utils/label';
import Step from './Step';
import BusCard from './BusCard';
import BusSelect from './BusSelect';

export default {
  components: {
    step: Step,
    'bus-card': BusCard,
    'bus-select': BusSelect
  },
  props: {
    complete: {
      type: Boolean,
      default: false
    },
    step: {
      type: [Number, String],
      default: 3
    },
    trip: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      types: {
        'motorcoach': 'Motor Coach',
        'doubledecker': 'Double Decker',
        'minibus': 'Mini Bus',
        'executivecoach': 'Executive Coach',
        'partybus': 'Party Bus',
        'schoolbus': 'School Bus',
        'entertainercoach': 'Entertainer Coach',
        'trolley': 'Trolley',
        'van': 'Van'
      },
      buses: [],
      selectedBus: null,
      title: 'Bus Selection',
      icon: 'mdi-bus',
      loading: false
    }
  },
  computed: {
    defaultBuses () {
      return []
    },
    selectableBuses () {
      return this.busTypes.filter(b => !!b)
        .map(b => ({ text: this.types[b.type], value: b.id }));
    },
    ...mapGetters('vehicles', { busTypes: 'types' }),
    ...mapGetters('user', { userId: 'id' }),
    ...mapGetters('dispatch', { dispatchId: 'id' }),
    ...mapGetters('operator', { operatorId: 'id' })
  },
  methods: {
    submit () {
      this.loading = true
      if (!this.buses) {
        // no buses have been selected, return
        return
      }
      const payload = Object.assign({}, this.trip)
      delete payload.trip_planner
      payload.busTypes = this.buses.map(bus => bus.id)
      return this.updateBusTypes(payload).then(() => {
        this.loading = false
        this.$emit('continue')
      }).catch(e => {
        this.loading = false
        this.raiseError(e)
      })
    },
    confirmSelectedBus (idx) {
      if (!idx) {
        this.buses.push(this.busTypes.find(b => b.id === this.selectedBus))
        return
      }
      this.buses.splice(idx, 1, this.busTypes.find(b => b.id === this.selectedBus))
      this.selectedBus = null
    },
    ...mapActions('plan', [ 'updateBusTypes' ]),
    ...mapActions('app', ['raiseError'])
  }
}
</script>

<style lang="css" scoped>
</style>
